import { render, staticRenderFns } from "./Numerus.global.vue?vue&type=template&id=521ef7f2&lang=pug&"
import script from "./Numerus.global.vue?vue&type=script&lang=ts&"
export * from "./Numerus.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports